import { useMemo } from "react";
import classNames from "classnames";
import { TransactionForReconciliation } from "../../common/contracts/reconciliation.contract";
import { currencyFormatter } from "../../common/helpers/currency";
import { dateFormatter } from "../../common/helpers/date";
import styles from "./Reconciliation.module.scss";

interface Props {
    transaction?: TransactionForReconciliation;
    isAdded?: boolean;
    isRemoved?: boolean;
}

export const ReconciliationTransaction: React.FC<Props> = ({
    transaction,
    isAdded,
    isRemoved,
}) => {
    const date = useMemo(
        () => (transaction?.date ? new Date(transaction?.date) : undefined),
        [transaction?.date],
    );

    const className = classNames({
        [styles.addedTransaction]: isAdded,
        [styles.removedTransaction]: isRemoved,
    });

    return (
        <>
            <div className={className}>
                {date && dateFormatter.format(date)}
            </div>
            <div className={className}>{transaction?.bankDescription}</div>
            <div className={classNames(className, styles.transactionAmount)}>
                {transaction && currencyFormatter.format(transaction.amount)}
            </div>
        </>
    );
};
